import React from 'react';
import { RefreshButton } from '../../../CommonComponents/RefreshButton/RefreshButton';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { MGP_WARMUP_LOADING_TEXT } from '../../MoneyGuideProConstants';
import { MgpSlug } from '../../MoneyGuideProTypes';
import { GoalsLoading } from '../../Goals/Goals.loading';
import { InsuranceLoading } from '../../Insurance/Insurance.loading';
import { NetWorthLoading } from '../../NetWorth/NetWorth.loading';
import { SummaryLoading } from '../../Summary/Summary.loading';
import { TabHeaderSkeleton } from '../TabHeader/components/TabHeaderSkeleton';

const TAB_TITLE_MAP: Record<MgpSlug, string> = {
  [MgpSlug.Summary]: 'Plan Summary',
  [MgpSlug.Insurance]: 'Insurance Policies',
  [MgpSlug.Goals]: 'Reaching Your Goals',
  [MgpSlug.Networth]: 'Net Worth Summary',
};

const LOADING_COMPONENT_MAP = {
  [MgpSlug.Summary]: SummaryLoading,
  [MgpSlug.Insurance]: InsuranceLoading,
  [MgpSlug.Goals]: GoalsLoading,
  [MgpSlug.Networth]: NetWorthLoading,
};

interface Props {
  tabSlug: string;
}

export const MgpWarmupLoading = ({ tabSlug }: Props) => {
  if (!(tabSlug in LOADING_COMPONENT_MAP)) {
    return null;
  }

  const slug = tabSlug as MgpSlug;
  const LoadingComponent = LOADING_COMPONENT_MAP[slug];
  const title = TAB_TITLE_MAP[slug];

  return (
    <>
      <TabHeaderSkeleton title={title}>
        <RefreshButton
          isLoading
          helperLoadingText={MGP_WARMUP_LOADING_TEXT}
          helperText="Last Updated:"
        />
      </TabHeaderSkeleton>
      <Box mx="8">
        <LoadingComponent />
      </Box>
    </>
  );
};
